import { useSearchParams } from "next/navigation"

export const useArticlesHasFilter = (): boolean => {
  const searchParams = useSearchParams()

  return searchParams.has("articlesSubject") || searchParams.has("articlesExclusive")
}
